
import { createSlice } from '@reduxjs/toolkit';

export interface CompetitionProjectsSliceStates {
    selectedCompetitions?: any[];
    isCompetitionsProjectsModalOpen?: boolean;
    projectCompetitions?: any[];
}

export const CompetitionProjects = createSlice({
    name: 'competitionProjects',
    initialState: {
        selectedCompetitions: [],
        isCompetitionsProjectsModalOpen: false,
        projectCompetitions: []
    },
    reducers: {
        setProjectCompetitions: (state, action) => {
            state.projectCompetitions = action.payload;
        },
        setSelectedProjectList: (state, action) => {
            state.selectedCompetitions = action.payload.data;
        },
        clearSelectedProjectList: (state, action) => {
            state.selectedCompetitions = [];
        },
        setIsModalIsOpen: (state, action) => {
            state.isCompetitionsProjectsModalOpen = action.payload.data;
        },
    },
});

export default CompetitionProjects
export const CompetitionProjectsActions = CompetitionProjects.actions
export const CompetitionProjectsSelector = (store: { competitionProjects: CompetitionProjectsSliceStates }): CompetitionProjectsSliceStates => store.competitionProjects;

import { createSlice } from '@reduxjs/toolkit';

export interface CompetitionProjectsSliceStates {
    selectedCompetitions?: any[];
    isCompetitionsProjectsModalOpen?: boolean;
    projectCompetitions?: any[];
}

export const CompetitionProjects = createSlice({
    name: 'competitionProjects',
    initialState: {
        selectedCompetitions: [],
        isCompetitionsProjectsModalOpen: false,
        projectCompetitions: []
    },
    reducers: {
        setProjectCompetitions: (state, action) => {
            state.projectCompetitions = action.payload;
        },
        setSelectedProjectList: (state, action) => {
            state.selectedCompetitions = action.payload.data;
        },
        clearSelectedProjectList: (state, action) => {
            state.selectedCompetitions = [];
        },
        setIsModalIsOpen: (state, action) => {
            state.isCompetitionsProjectsModalOpen = action.payload.data;
        },
    },
});

export default CompetitionProjects
export const CompetitionProjectsActions = CompetitionProjects.actions
export const CompetitionProjectsSelector = (store: { competitionProjects: CompetitionProjectsSliceStates }): CompetitionProjectsSliceStates => store.competitionProjects;
